<template>
    <v-app :key="$route.path">
        <nav-bar @open-drawer="toggleDrawer" class="nav-bar2" />
        <v-main class="split-layout">
            <v-container fluid class="page-content">
                <div>
                    <RouterView />
                </div>
            </v-container>
        </v-main>

        <offline-snackbar/>
        <!-- <prescription-counter /> -->
    </v-app>
</template>

<script>
// import navDrawer from "@/components/global/nav-drawer.vue";
import navBar from '@/components/global/nav-bar.vue';
import offlineSnackbar from '@/components/global/offline-alert.vue';
// import prescriptionCounter from '@/components/global/prescription-counter.vue';

export default {
    name: 'default-page',
    components: {
        'nav-bar': navBar,
        'offline-snackbar': offlineSnackbar,
        // 'prescription-counter': prescriptionCounter,
    },
    data() {
        return {
            isDrawerOpen: true,
        };
    },
    methods: {
        toggleDrawer() {
            this.isDrawerOpen = !this.isDrawerOpen;
        },
    },
};
</script>
